import React from "react"
import Header from "./components/Header"
import {BrowserRouter, Routes,  Route} from "react-router-dom"
import Home from "./components/Home"
import About from "./components/About"
import Projects from "./components/Projects"
import Skills from "./components/Skills"
import Contact from "./components/Contact"
import Portfolio from "./components/Portfolio"
//import {AnimatePresence} from "framer-motion"


const App = () => {
   

    return (
        <div>
          
            <div>
               
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Portfolio />} />
                </Routes>
            </BrowserRouter>  
            </div>
        </div>
        
    )
}

export default App